import { useSelector } from "react-redux";
import { RootState } from "../store";
import { FinancialFormState } from "../store/reducers/financialFormReducer";

export const useFinancialForm = (): FinancialFormState =>
  useSelector((state: RootState) => state.financialFormReducer);
